import {
  GET_PORTS,
  GET_LOAD_PORTS,
  GET_DISCHARGE_PORTS,
  GET_MANUAL_TRACKING_MASTER,
} from './routes';
import { API_BASE_URL } from '../globals';
import { GET } from './apiHandler';

export const getPorts = async (
  params: any = { queryString: ' ' },
  portApi: null | string = null,
) => {
  const apiURLMap = {
    loadport: GET_LOAD_PORTS,
    dischargeport: GET_DISCHARGE_PORTS,
  };
  return GET(
    `${API_BASE_URL}${(portApi && apiURLMap[portApi]) ? apiURLMap[portApi] : GET_PORTS}`,
    params,
  );
};

export const fetchManualTrackingMasterData = async (params) => {
  return GET(`${API_BASE_URL}${GET_MANUAL_TRACKING_MASTER}`, params);
};
